export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/pt-br.lyaml"));
vm(require("foundations-components/lang/pt-br.lyaml"));
vm(require("feature-monetization/lang/pt-br.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/pt-br.lyaml"));
vm(require("usage-based-billing-components-lib/lang/pt-br.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/header/pt-br.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/marketing-hub/pt-br.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card/pt-br.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-copy/pt-br.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-price/pt-br.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-term/pt-br.lyaml"));
at({ "pt-br": { "ui": { "UILoadingSpinner": { "busyText": "Carregando", "completedText": "Carregado" } }, "publicPricingPage": { "windowTitles": { "default": "Pre\xE7os | HubSpot" } } } });
};